/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scriptEditor.vue?vue&type=template&id=06f12356&scoped=true"
import script from "./scriptEditor.vue?vue&type=script&lang=js"
export * from "./scriptEditor.vue?vue&type=script&lang=js"
import style0 from "./scriptEditor.vue?vue&type=style&index=0&id=06f12356&prod&lang=scss&scoped=true"
import style1 from "./scriptEditor.vue?vue&type=style&index=1&id=06f12356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f12356",
  null
  
)

export default component.exports